export default __webpack_public_path__ + "static/media/EyeIcon.79e4dcfe.svg";